<template>
  <BaseButton primary @click="open"> Add Approval Request </BaseButton>
</template>

<script>
import { projectAssetApprovalRequestsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('./ApprovalRequestCreateModal.vue'),
        props: {
          projectId: this.projectAsset.projectId,
          action: async (formData) => {
            this.loading = true;

            try {
              await projectAssetApprovalRequestsClient.store(
                this.projectAsset.id,
                mapKeysToSnakeCase(formData)
              );

              this.$emit('approval-request-created');

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            } finally {
              this.loading = false;
            }
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
